import axios from "axios";

const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const filereader = new FileReader();
    filereader.readAsDataURL(file);

    filereader.onload = () => {
      resolve(filereader.result);
    };

    filereader.onerror = (error) => {
      reject(error);
    };
  });
};

const convertURL = async (base64) => {
  return await axios.post("https://uplbidet-api.vercel.app/upload-image", {
    image: base64,
  });
};

export { convertBase64, convertURL };
